module.exports = __webpack_public_path__ + "img/LUB00376.91ffe53f.png";